'use strict';
/**
 * GetUserMedia telemetry events
 * @internal
 */
class GetUserMediaEvents {
    /**
     * @param {import('../telemetry')} telemetry - The telemetry instance
     */
    constructor(telemetry) {
        this._telemetry = telemetry;
    }
    /**
     * Emit when getUserMedia succeeds
     * @returns {void}
     */
    succeeded() {
        this._telemetry.info({
            group: 'get-user-media',
            name: 'succeeded'
        });
    }
    /**
     * Emit when getUserMedia is denied by user
     * @returns {void}
     */
    denied() {
        this._telemetry.info({
            group: 'get-user-media',
            name: 'denied'
        });
    }
    /**
     * Emit when getUserMedia fails (non-permission error)
     * @param {Error} error - The error from getUserMedia
     * @returns {void}
     */
    failed(error) {
        this._telemetry.info({
            group: 'get-user-media',
            name: 'failed',
            payload: {
                name: error.name,
                message: error.message
            }
        });
    }
}
module.exports = GetUserMediaEvents;
//# sourceMappingURL=getusermedia.js.map